export default __webpack_public_path__ + "static/media/Target.f7d1f525.svg";